import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Loader2, Mail } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export default function Contactos() {
  const [form, setForm] = useState({ nome: "", email: "", assunto: "", mensagem: "" });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api.post("/contactos", form);
      setSuccess(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <div className="max-w-2xl mx-auto px-5 sm:px-8 py-16">
        <div className="ldr-card ldr-success p-8 sm:p-10 text-center" data-testid="contactos-success">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full ldr-success-icon">
            <CheckCircle2 size={30} />
          </div>
          <h1 className="mt-6 text-2xl sm:text-3xl font-bold ldr-success-title">
            A sua mensagem foi enviada. Será contactado nas próximas 48 horas.
          </h1>
          <button
            type="button"
            className="ldr-btn-outline mt-8"
            onClick={() => {
              setSuccess(false);
              setForm({ nome: "", email: "", assunto: "", mensagem: "" });
            }}
            data-testid="contactos-new-btn"
          >
            Enviar nova mensagem
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto px-5 sm:px-8 py-12 sm:py-16">
      <header className="mb-10">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--ldr-red)]">
          Fale connosco
        </p>
        <h1 className="mt-3 text-3xl sm:text-4xl font-bold">Contactos</h1>
        <p className="mt-3 text-[var(--ldr-text-muted)] leading-relaxed">
          Envie-nos a sua mensagem. Para pedidos de reembolso, utilize
          o <Link to="/reembolso" className="underline underline-offset-4">formulário de reembolso</Link>.
        </p>
      </header>

      <form onSubmit={onSubmit} className="ldr-card p-6 sm:p-8 space-y-5" data-testid="contactos-form">
        <div>
          <label className="ldr-label" htmlFor="c-nome">Nome <span className="text-[var(--ldr-red)]">*</span></label>
          <input
            id="c-nome" name="nome" required value={form.nome} onChange={onChange}
            className="ldr-input" placeholder="Nome completo"
            data-testid="contactos-input-nome"
          />
        </div>
        <div>
          <label className="ldr-label" htmlFor="c-email">Email <span className="text-[var(--ldr-red)]">*</span></label>
          <input
            id="c-email" name="email" type="email" required value={form.email} onChange={onChange}
            className="ldr-input" placeholder="nome@exemplo.pt"
            data-testid="contactos-input-email"
          />
        </div>
        <div>
          <label className="ldr-label" htmlFor="c-assunto">Assunto <span className="text-[var(--ldr-red)]">*</span></label>
          <input
            id="c-assunto" name="assunto" required value={form.assunto} onChange={onChange}
            className="ldr-input" placeholder="Como podemos ajudar?"
            data-testid="contactos-input-assunto"
          />
        </div>
        <div>
          <label className="ldr-label" htmlFor="c-mensagem">Mensagem <span className="text-[var(--ldr-red)]">*</span></label>
          <textarea
            id="c-mensagem" name="mensagem" required rows={6}
            value={form.mensagem} onChange={onChange}
            className="ldr-input resize-y"
            placeholder="Descreva o seu pedido…"
            data-testid="contactos-input-mensagem"
          />
        </div>

        {error && (
          <div className="text-sm text-[var(--ldr-red)] bg-[#FBEAEA] border border-[#F0CBCC] rounded-md px-4 py-3"
               data-testid="contactos-error">
            {error}
          </div>
        )}

        <div className="pt-2">
          <button
            type="submit"
            disabled={submitting}
            className="ldr-btn-primary w-full sm:w-auto"
            data-testid="contactos-submit"
          >
            {submitting ? <Loader2 size={16} className="animate-spin" /> : <Mail size={16} />}
            {submitting ? "A enviar…" : "Enviar mensagem"}
          </button>
        </div>
      </form>
    </div>
  );
}
